import "./BNGUnitsKPI.css";

interface BNGUnitsKPIProps {
  units: number;
}

export const BNGUnitsKPI = ({ units }: BNGUnitsKPIProps): JSX.Element => {
  return (
    <div className="BNGUnitsContainer">
      <h2>{units}</h2>
      <p className="body1">BNG units</p>
    </div>
  );
};
